<template lang="pug">
  modal.modal(:title='$t("createSharingGroupModal.createGroup")' @closeModal='hideElement({element: "createSharingGroupModal"})')
    .container.relative
      .trial.row.middle.center(v-if='isTrial')
        .row.middle.center
          simple-svg.dark-gray-icon.m-right-1(:filepath='lockIcon' width='20px' height='20px')
          h2.text-normal.dark-gray {{ $t('trial.disabledOnTrial') }}
      .row.middle.m-top-2
        simple-svg.group-icon(:filepath='groupIcon' width='32px' height='32px')
        krea-text-area.name-input.m-left-2.item-1(
          noActions height='55px' fontSize='28px'
          :maxCharacters='30' name='name'
          :placeholder='$t("createSharingGroupModal.groupNamePlaceholder")'
          size='title-big'
          :value='sharingGroup.name'
          :updateMethod='updateName'
        )
      .column.m-top-1
        h2.text-normal.dark-gray {{ $t('createSharingGroupModal.addMembers') }}
        .search.relative
          simple-svg.gray-icon.absolute.icon(:filepath='searchIcon' width='16px' height='16px')
          input.input-base.input-border.input(
            v-model='filters.search'
            :placeholder='$t("createSharingGroupModal.searchPlaceholder")'
            @keypress.enter='filterUsers'
          )
      .users-list.kimple-scroll.m-top-1
        .loader.row.middle(v-if='loadingUsers')
          loader(size='inner')
        .user.row.middle(v-else v-for='user in users' :key='user.userId')
          checkbox.check(
            name='user'
            :checked='isUserSelected(user.userId)'
            :updateCheck='(name, value) => toggleSelected(user.userId, value)'
            transparent
          )
          img.avatar(:src='user.avatar || defaultProfileImage').column.m-left-1
          .column.m-left-1
            .row.middle.ellipsis.username
              h2.text-normal.m-right-05 {{ user.fullName }}
              h2.text-normal.ellipsis(
                v-if='user.position.positionId || user.schoolName'
                :title='getPositionWithSchoolName(user.position, user.schoolName)'
              ) {{ getPositionWithSchoolName(user.position, user.schoolName) }}
            h4.text-small.dark-gray {{ user.email }}
      .row.end.m-top-2
        button.primary-button(@click='submit') {{ $t('createSharingGroupModal.createGroup') }}
</template>

<script>
import Modal from '@/components/Modal'
import groupIcon from '@/assets/ic_group.svg'
import searchIcon from '@/assets/ic_search.svg'
import defaultProfileImage from '@/assets/empty_profile.svg'
import KreaTextArea from '@/components/Krea/Inputs/KreaTextArea'
import Checkbox from '@/components/Inputs/Checkbox'
import Loader from '@/components/Loader'
import TextInput from '@/components/Inputs/TextInput'
import { mapActions, mapState } from 'vuex'
import lockIcon from '@/assets/ic_lock.svg'
import userRole from '../../mixins/userRole'
import userPosition from '@/mixins/userPosition'

export default {
  mixins: [userRole, userPosition],
  components: { Loader, Modal, KreaTextArea, TextInput, Checkbox },
  data() {
    return {
      lockIcon,
      defaultProfileImage,
      groupIcon,
      searchIcon,
      groupName: '',
      loadingUsers: true,
      selectedUsers: [],
      filters: {
        search: ''
      }
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.createSharingGroupModal.props,
      users: state => state.userInfo.searchedUsers,
      sharingGroup: state => state.sharingGroup.sharingGroup
    })
  },
  async created() {
    this.clearSharingGroup()
    await this.searchUsers(this.filters)
    this.loadingUsers = false
  },
  methods: {
    ...mapActions([
      'searchUsers',
      'showElement',
      'hideElement',
      'clearSharingGroup',
      'createSharingGroup',
      'editSharingGroupField',
      'addSharingGroupMember',
      'removeSharingGroupMember'
    ]),
    async filterUsers() {
      this.selectedUsers = []
      this.loadingUsers = true
      await this.searchUsers(this.filters)
      this.loadingUsers = false
    },
    updateName(value) {
      this.editSharingGroupField({ field: 'name', value })
    },
    toggleSelected(userId, value) {
      if (value) this.addSharingGroupMember(userId)
      else this.removeSharingGroupMember(userId)
    },
    isUserSelected(userId) {
      return Boolean(this.sharingGroup.userSharingGroups.find(user => user.userId === userId))
    },
    async submit() {
      this.showElement({ element: 'fullPageLoader' })
      const { success } = await this.createSharingGroup()
      this.hideElement({ element: 'fullPageLoader' })
      if (success) {
        this.hideElement({ element: 'createSharingGroupModal' })
        this.showElement({ element: this.modalProps.source, props: this.modalProps.sourceProps })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.modal{
  --max-width: 620px;
}

.container{
  .trial{
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(1px);
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
}

.group-icon{
  border-radius: 50%;
  padding: 6px;
  border: 1px solid $gray;
}

.search{
  .icon{
    top: 20px;
    left: 10px;
  }
  .input{
    padding-left: 35px;
  }
}

.users-list{
  overflow-y: auto;
  height: 500px;
  .loader{
    height: 100%;
  }
  &>:nth-child(even){
    background-color: $light-gray;
  }
  .user {
    padding: 10px;
    height: 50px;
    .username{
      max-width: 420px;
    }
    .avatar{
      width: 35px;
      height: 35px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}
</style>
